import { render, staticRenderFns } from "./EmailConfigLogs.vue?vue&type=template&id=4466b891&"
import script from "./EmailConfigLogs.vue?vue&type=script&lang=js&"
export * from "./EmailConfigLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports